import { render, staticRenderFns } from "./TraceyAiSidebar.vue?vue&type=template&id=2123974a&scoped=true"
import script from "./TraceyAiSidebar.vue?vue&type=script&lang=js"
export * from "./TraceyAiSidebar.vue?vue&type=script&lang=js"
import style0 from "./TraceyAiSidebar.vue?vue&type=style&index=0&id=2123974a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123974a",
  null
  
)

export default component.exports